import { School } from "../types/types";
import { SCHOOLS_ENDPOINTS } from "../constants/api";
import { privateApiClient } from "../utils/axios.utils";

/**
 * Exam Type Service
 * This service handles all API calls related to exam Types.
 */
export const SchoolService = {
  createSchool: async (data: Partial<School>) => {
    const response = await privateApiClient.post(
      SCHOOLS_ENDPOINTS.CREATE,
      data
    );

    return response.data.data;
  },

  getOwnSchool: async () => {
    const response = await privateApiClient.get(
      SCHOOLS_ENDPOINTS.GET_OWN_SCHOOL
    );

    return response.data.data;
  },

  getAllSchools: async (limit?: number) => {
    const params = limit !== undefined ? { limit } : { limit: 1000 }; // 0 or undefined will fetch all
    const response = await privateApiClient.get(SCHOOLS_ENDPOINTS.GET_ALL, {
      params,
    });

    return response.data.data;
  },

  updateSchool: async (id: number, data: Partial<School>) => {
    const response = await privateApiClient.put(
      SCHOOLS_ENDPOINTS.UPDATE(id),
      data
    );

    return response.data.data;
  },

  deleteSchool: async (id: number) => {
    const response = await privateApiClient.delete(
      SCHOOLS_ENDPOINTS.DELETE(id)
    );

    return response.data.data;
  },

  getSchoolById: async (id: number) => {
    const response = await privateApiClient.get(
      SCHOOLS_ENDPOINTS.GET_BY_ID(id)
    );

    return response.data.data;
  },
};
